export const getShortWalletAddress = (str) => {
    if (str.length <= 10) {
        return str;
    }

    const firstPart = str.slice(0, 6);
    const lastPart = str.slice(-4);
    return `${firstPart}...${lastPart}`;
};
